import { configureStore } from '@reduxjs/toolkit'
import { taskDetail } from './components/edvenswa.emportal.timesheet/features/userDetailSlice'

export const store = configureStore({
    reducer: {
        app: taskDetail.reducer,
    },
})